import { render, staticRenderFns } from "./travelNav.vue?vue&type=template&id=3fbcf2c4&scoped=true&"
import script from "./travelNav.vue?vue&type=script&lang=js&"
export * from "./travelNav.vue?vue&type=script&lang=js&"
import style0 from "./travelNav.vue?vue&type=style&index=0&id=3fbcf2c4&lang=sass&scoped=true&"
import style1 from "./travelNav.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fbcf2c4",
  null
  
)

export default component.exports